// extracted by mini-css-extract-plugin
module.exports = {"logoTJA":"FormularioIniciarComponent_logoTJA__1zSOk"};